export enum DebtCollectionStatus {
  NORMAL = "NORMAL",
  SUBJECT_FOR_COLLECTION = "SUBJECT_FOR_COLLECTION",
  APPROVED_FOR_COLLECTION = "APPROVED_FOR_COLLECTION",
  COLLECTION_BLOCKED = "COLLECTION_BLOCKED",
  COLLECTION_CREATED = "COLLECTION_CREATED",
  COLLECTION_SENT = "COLLECTION_SENT",
}
